<i class="fas" [class]="iconClass" [matTooltip]="tooltipText" [matTooltipPosition]="position" [matTooltipClass]="tooltipClass"></i>